import { useGetIdentity, useTranslate } from "ra-core";
import { CreateSheet } from "../../misc/CreateSheet";
import { PaymentInputs } from "./PaymentInputs";

interface PaymentCreateSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const PaymentCreateSheet = ({ open, onOpenChange }: PaymentCreateSheetProps) => {
  const { identity } = useGetIdentity();
  const translate = useTranslate();
  return (
    <CreateSheet
      resource="payments"
      title={translate("resources.payments.action.new", { _: "Новый платёж" })}
      defaultValues={{
        sales_id: identity?.id,
        status: "pending",
        planned_date: new Date().toISOString().slice(0, 10),
        amount: 0,
      }}
      open={open}
      onOpenChange={onOpenChange}
    >
      <PaymentInputs />
    </CreateSheet>
  );
};
